import React from 'react';
import PropTypes, { string } from 'prop-types';
import { grey_1000 } from '@fiverr-private/sass/helpers';
import Icon from '../Icon';
import { r_spinner_animated } from '../../../icons';
import { SIZE_MAP, SIZES } from './constants';

/**
 * @deprecated Please use Loader from @fiverr-private/feedback instead.
 */
const Loader = ({ size, color }) => (
    <Icon size={SIZE_MAP[size]}
        color={color}>
        {r_spinner_animated}
    </Icon>
);

Loader.displayName = 'Loader';

Loader.propTypes = {
    /**
     * The tag's size.
     * Supported options are exposed through the static `SIZES` property.
     */
    size: PropTypes.oneOf(Object.values(SIZES)),
    /**
     * The Loader's color.
     * any color from our design system.
     */
    color: string
};

Loader.defaultProps = {
    size: SIZES.MD,
    color: grey_1000
};

Object.assign(Loader, { SIZES });

export default Loader;
